/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ChangeRequestUserContributor, List } from "./data-contracts";

/**
 * No description
 * @tags change-request-contributors
 * @name GetContributorsByChangeRequestId
 * @summary Get all contribors of a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/contributors
 * @secure
 */

// @ts-ignore
export const getContributorsByChangeRequestId: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequestUserContributor[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/contributors",
  method: "get",
  streaming: false,
  tags: ["change-request-contributors"],
  criticalityLevel: "low",
  deprecated: false,
};
